// 职业探索
import React from 'react';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetMenu from '../../widget/WidgetMenu';
import WidgetSlideUpOverlay from '../../widget/WidgetSlideUpOverlay';
import WidgetListVerticalTable from '../../widget/WidgetListVerticalTable';
import WidgetMessage from '../../widget/WidgetMessage';

class CareerEvaluation extends React.Component 
{
    constructor( props )
    {
        super(props);

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            basePath: Config.getBasePath(),

            sourcePath: Config.getSourcePath(),

            userInfo: userInfo || {},
            welcomeWord:"欢迎来到职业测评，让我来帮助你更快更准找到自己的职业方向！",

            items:[
                {key:"all", label:"全部"},
                {key:"1", label:"兴趣&性格"},
                {key:"2", label:"态度&评价"},
                {key:"3", label:"能力&素养", children:[
                    {key:"3-1", label:"基础能力"},
                    {key:"3-2", label:"自我管理"},
                    {key:"3-3", label:"任务执行"},
                    {key:"3-4", label:"人际关系"},
                    {key:"3-5", label:"团队协作"},
                    {key:"3-6", label:"创新创业"}
                ]},
                {key:"4", label:"生涯&决策"},
                {key:"5", label:"趣味&娱乐"}
            ],
            itemValues:["all"],

            data:[],
            total:0,
            page:1,
            loading:false,
            pageSize:9
        }
    }

    componentDidMount()
    {
        this.loadData();
    }

    loadData = () => {

        const { page=1 , pageSize=9, itemValues, basePath } = this.state;

        let params = {
            page: page,
            records:pageSize,
            type:itemValues[0]
        }

        this.setState({loading:true, page:page, pageSize:pageSize});

        const onLoadData = (result, params ) => {

            if( result.status===0 )
            {
                this.setState({data:result.results, total:result.total, loading:false});
            }
            else
            {
                WidgetMessage.error(result.message);
            }
        }

        WidgetAjax.ajax({url:basePath + "/career/test_list", params:params, callback:onLoadData}, this.props);

    }

    itemChange = (item, key, keyPath) => { 

        this.setState({itemValues:[key]});
    }

    notify = (type, item) => {

        switch( type )
        {
            case "click":
            {
                this.props.history.push({pathname:"/home/career-evaluation-info/"  + item.id, state:{item:item}});
                break;
            }
            
        }
    }

    pageTurning = (page, pageSize) => {
        this.setState({page:page, pageSize:pageSize}, () => {
            this.loadData();
        })
    }


    render()
    {
        const { sourcePath, userInfo, welcomeWord,itemValues=[], items=[], data = [], loading, pageSize, total, page} = this.state;
        
        return (
            <div className="sf-page" component-data="career-evaluation">
                <div className='sf-career-top' style={{minHeight:905}}>
                    <div className='sf-career-top-body sf-padding-50'>
                        <div className='sf-career-evaluation'>
                            <div className='sf-career-title-welcome'>
                                <div className='sf-vertical-line'></div>
                                <div className='sf-welcome-right'>
                                    <span>Hello，{ userInfo.realname }！ </span>
                                    <div className='sf-welcome'>
                                        <span className='sf-welcome-message'> {welcomeWord}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='sf-career-explore-recommend'>
                                <div className='sf-career-explore-title'>
                                    <div className='sf-career-explore-title-body'>
                                        <img src={require('./../../img/' + sourcePath + '/career/career-icon.png')} alt=""></img>
                                        <div className='sf-career-explore-title-now'>职业测评四要素</div>
                                    </div>
                                </div>

                                <div className='sf-career-evaluation-overlay'>
                                    <WidgetSlideUpOverlay
                                        delay={500} // 500毫秒延迟
                                        overlayBg="bg-gradient-to-t from-black/90 to-black/60"
                                        animationDuration={600}
                                        overlayContent={
                                            <div className="sf-career-item-overlay">
                                                <div className="sf-career-item-overlay-title">规划未来，成就自我！</div>
                                                <div className="sf-career-item-overlay-description">霍兰德职业兴趣自测（Self-Directed Search）是由美国职业指导专家霍兰德（John Holland）根据他本人大量的职业咨询经验及其职业类型理论编制的测评工具。</div>
                                                <div className="sf-career-item-overlay-operation">
                                                    <button className="sf-career-item-overlay-button">
                                                        进入
                                                    </button> 
                                                </div>
                                            </div>
                                        }
                                        >
                                        <div className='sf-career-item'>
                                            <div className='sf-career-evaluation-top'>
                                                <img src={require('./../../img/' + sourcePath + '/career/evaluation.png')} alt=""></img>
                                            </div>
                                            <div className='sf-career-evaluation-body'>
                                                <div className='sf-career-evaluation-title'>
                                                    <div>职业</div>
                                                    <div>能力</div>
                                                </div>
                                                <div className='sf-career-evaluation-content'>
                                                    通过考察个人在工作中所需要的专业技能、知识、能力等方面的表现来评估其职业能力水平
                                                </div>
                                            </div>
                                        </div>
                                    </WidgetSlideUpOverlay>

                                    <WidgetSlideUpOverlay
                                        delay={500} // 500毫秒延迟
                                        overlayBg="bg-gradient-to-t from-black/90 to-black/60"
                                        animationDuration={600}
                                        overlayContent={
                                            <div className="sf-career-item-overlay">
                                                <div className="sf-career-item-overlay-title">规划未来，成就自我！</div>
                                                <div className="sf-career-item-overlay-description">霍兰德职业兴趣自测（Self-Directed Search）是由美国职业指导专家霍兰德（John Holland）根据他本人大量的职业咨询经验及其职业类型理论编制的测评工具。</div>
                                                <div className="sf-career-item-overlay-operation">
                                                    <button className="sf-career-item-overlay-button">
                                                        进入
                                                    </button> 
                                                </div>
                                            </div>
                                        }
                                        >
                                        <div className='sf-career-item'>
                                            <div className='sf-career-evaluation-top'>
                                                <img src={require('./../../img/' + sourcePath + '/career/evaluation.png')} alt=""></img>
                                            </div>
                                            <div className='sf-career-evaluation-body'>
                                                <div className='sf-career-evaluation-title'>
                                                    <div>职业</div>
                                                    <div>兴趣</div>
                                                </div>
                                                <div className='sf-career-evaluation-content'>
                                                    从兴趣的角度出发探索职业指导的问题发现和确定自己的职业方向
                                                </div>
                                            </div>
                                        </div>
                                    </WidgetSlideUpOverlay>

                                    <WidgetSlideUpOverlay
                                        delay={500} // 500毫秒延迟
                                        overlayBg="bg-gradient-to-t from-black/90 to-black/60"
                                        animationDuration={600}
                                        overlayContent={
                                            <div className="sf-career-item-overlay">
                                                <div className="sf-career-item-overlay-title">规划未来，成就自我！</div>
                                                <div className="sf-career-item-overlay-description">霍兰德职业兴趣自测（Self-Directed Search）是由美国职业指导专家霍兰德（John Holland）根据他本人大量的职业咨询经验及其职业类型理论编制的测评工具。</div>
                                                <div className="sf-career-item-overlay-operation">
                                                    <button className="sf-career-item-overlay-button">
                                                        进入
                                                    </button> 
                                                </div>
                                            </div>
                                        }
                                        >
                                        <div className='sf-career-item'>
                                            <div className='sf-career-evaluation-top'>
                                                <img src={require('./../../img/' + sourcePath + '/career/evaluation.png')} alt=""></img>
                                            </div>
                                            <div className='sf-career-evaluation-body'>
                                                <div className='sf-career-evaluation-title'>
                                                    <div>职业</div>
                                                    <div>性格</div>
                                                </div>
                                                <div className='sf-career-evaluation-content'>
                                                    通过评估个人的性格特点和行为风格来评估其在不同职业环境中的表现和适应度
                                                </div>
                                            </div>
                                        </div>
                                    </WidgetSlideUpOverlay>

                                    <WidgetSlideUpOverlay
                                        delay={500} // 500毫秒延迟
                                        overlayBg="bg-gradient-to-t from-black/90 to-black/60"
                                        animationDuration={600}
                                        overlayContent={
                                            <div className="sf-career-item-overlay">
                                                <div className="sf-career-item-overlay-title">规划未来，成就自我！</div>
                                                <div className="sf-career-item-overlay-description">霍兰德职业兴趣自测（Self-Directed Search）是由美国职业指导专家霍兰德（John Holland）根据他本人大量的职业咨询经验及其职业类型理论编制的测评工具。</div>
                                                <div className="sf-career-item-overlay-operation">
                                                    <button className="sf-career-item-overlay-button">
                                                        进入
                                                    </button> 
                                                </div>
                                            </div>
                                        }
                                        >
                                        <div className='sf-career-item'>
                                            <div className='sf-career-evaluation-top'>
                                                <img src={require('./../../img/' + sourcePath + '/career/evaluation.png')} alt=""></img>
                                            </div>
                                            <div className='sf-career-evaluation-body'>
                                                <div className='sf-career-evaluation-title'>
                                                    <div>职业</div>
                                                    <div>价值</div>
                                                </div>
                                                <div className='sf-career-evaluation-content'>
                                                    通过考察个人对工作和职业生涯中重要价值观的认同程度来评估其对不同职业环境和组织文化的适应度
                                                </div>
                                            </div>
                                        </div>
                                    </WidgetSlideUpOverlay>
                                </div>
                            </div>

                   
                            <div className='sf-career-explore-recommend'>
                                <div className='sf-career-explore-title'>
                                    <div className='sf-career-explore-title-body'>
                                        <img src={require('./../../img/' + sourcePath + '/career/recommend.png')} alt=""></img>
                                        <div className='sf-career-explore-title-now'>更多测评</div>
                                    </div>
                                </div>

                                <div className='sf-career-explore-recommend-content'>
                                    <div className='sf-career-evaluation-menu'>
                                       <WidgetMenu values={itemValues} items={items} notify={this.itemChange}></WidgetMenu>
                                    </div>
                                    <div className='sf-career-evaluation-list'>
                                        <WidgetListVerticalTable loading={loading} data={data} total={total} page={page} notify={this.notify} 
                                            pageTurning={this.pageTurning} pageSize={pageSize}></WidgetListVerticalTable>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
                
            </div>
        )
    }
}
export default CareerEvaluation;